export const Styles = () => {
  return (
    <style>
      {`.container {
  position: relative;
}

.overlapBlock {
  position: absolute;
  top: 0;
  left: 0;
  background-color: #7e7e7e7f;
  display: flex;
  align-items: center;
  justify-content: center;
}

.playBtn {
  border: none;
  color: #000000;
  border-radius: 8px;
  font-size: 20px;
}

@keyframes flicker {
  0% {
    background-color: aliceblue;
  }
  50% {
    background-color: bisque;
  }
  100% {
    background-color: aliceblue;
  }
}`}
    </style>
  );
};
